import { Reducer } from 'redux';
import { ConsentsState, ConsentsActionTypes } from './types';
import { StudentActionTypes } from '../types';

const initialState: ConsentsState = {
  isSectionStarted: false,
  isSectionComplete: false
};

const reducer: Reducer<ConsentsState> = (state = initialState, action): ConsentsState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        ...action.payload.student.consents
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ...action.payload.consents
      };
    case ConsentsActionTypes.UPDATE_CONSENTS_FIELD:
      return {
        ...state,
        [action.payload.fieldName]: action.payload.value
      };
    default:
      return state;
  }
};

export { reducer as consentsReducer };
